import { AdapterDayjs } from 'EmbarkAdapterDayJS';
import { DateIOFormats } from '@date-io/core/IUtils'
import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { USER_LOCALE } from '@/util/environment'

dayjs.extend(timezone);
dayjs.extend(advancedFormat);

/* 
    Import all locale files
    https://webpack.js.org/guides/dependency-management/#requirecontext
*/
const requireLocale = require.context('dayjs/locale', false, /.js$/);
const userLocaleSearchValue: string = USER_LOCALE.toLowerCase();
let booLocaleMatchFound: boolean = false;

requireLocale.keys().forEach((fileName) => {
    requireLocale(fileName);

    if (fileName.includes(userLocaleSearchValue)) booLocaleMatchFound = true;
});

// fallback to root locale if no match is found in dayjs/locale (en-US > en)
let userLocale = booLocaleMatchFound ? userLocaleSearchValue : userLocaleSearchValue.split("-")[0];

dayjs.locale(userLocale);

export const dateAdapterInstance = new AdapterDayjs({locale: userLocale});

export const formatDate = (date: Dayjs | Date, formatKey: keyof DateIOFormats<string> = 'keyboardDate') => {
    return dateAdapterInstance.format(dayjs(date), formatKey)
}

export const formatDateTime = (date: Dayjs | Date, formatKey: string = 'L h:mm:ss A') => {
    return dateAdapterInstance.formatByString(dayjs(date), formatKey);
}

export const getTimezone = (date: Date) => {
    return dayjs(date).format('z');
}

export const isValidDate = (date: Date) => {
    return date.getFullYear() > 1;
}

export const dateToISOString = (date: Dayjs | Date) => {
    return dayjs(date).toISOString()
}

export const dayJsFormatDate = (date: Date | Dayjs, format: string) => {
    return dayjs(date).format(format);
}
export const calculateSeconds = (duration: number) => {
    if (duration === 0) {
        return '0s';
    } else {
        const timeComponents = [
            { value: Math.floor(duration / (24 * 3600)), label: 'd' },
            { value: Math.floor((duration % (24 * 3600)) / 3600), label: 'h' },
            { value: Math.floor((duration % 3600) / 60), label: 'm' },
            { value: Math.floor(duration % 60), label: 's' }
        ];

        const formattedTime = timeComponents
            .filter(component => component.value > 0)
            .map(component => `${component.value}${component.label}`)
            .join(' ');

        return formattedTime;
    }
}

export default AdapterDayjs;
